import * as React from 'react';
import { Dropdown } from '../../Partials/Dropdown/Dropdown';
import { smoothScrollToSectionById } from '../../Partials/Utils/utils';
import styles from './ArticleListAnchorSelect.module.css';
import type { ArticleListAnchorSelectViewModel } from './ArticleListAnchorSelectViewModel.csharp';

export const ArticleListAnchorSelect: React.FC<React.PropsWithChildren<ArticleListAnchorSelectViewModel>> = props => {
    const { sections, chooseCategoryTranslation } = props;

    return (
        <>
            {sections.length > 0 && (
                <Dropdown
                    className={styles.ArticleListAnchorSelect}
                    placeholder={chooseCategoryTranslation}
                    options={sections.map(section => ({ text: section.title, value: section.sectionBlockId }))}
                    onValueChanged={value => smoothScrollToSectionById(value)}
                />
            )}
        </>
    );
};
